import { AxiosResponse } from "axios";
import { api, IInsuranceSublineApi } from "./base";
import { Result } from "../models/common/resultResponse";
import { KeyValue } from "../models/common";

const baseRoute: string = "InsuranceSubline";
export class InsuranceSublineApi extends IInsuranceSublineApi {
	getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`);
	}
}
